import React from "react";
import { FEATURES } from "@/data/site";
import * as Icons from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeading from "@/components/SectionHeading";

export default function WhyChooseUs() {
  return (
    <section id="why" data-testid="why-section" className="py-20 md:py-28 px-5 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="Why Choose Us"
          title="Journeys crafted with care, delivered with excellence"
          subtitle="From your first enquiry to your final destination, our team ensures every detail is thoughtfully planned."
        />

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {FEATURES.map((f, i) => {
            const Icon = Icons[f.icon] || Icons.Sparkles;
            return (
              <Reveal key={f.title} delay={i * 80}>
                <div
                  data-testid={`feature-card-${i}`}
                  className="group card-lift bg-white rounded-2xl p-7 md:p-8 border border-gray-100 shadow-[0_2px_20px_-8px_rgba(11,61,145,0.15)] hover:border-[#4DA8FF]/30"
                >
                  <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-[#EAF3FF] to-[#F9FBFF] flex items-center justify-center group-hover:from-[#F9B233]/20 group-hover:to-[#F9B233]/10 transition-colors">
                    <Icon className="w-7 h-7 text-[#0B3D91] group-hover:text-[#F9B233] transition-colors" strokeWidth={2} />
                  </div>
                  <h3 className="mt-5 text-lg md:text-xl font-semibold text-[#222] tracking-tight">{f.title}</h3>
                  <p className="mt-3 text-sm md:text-[15px] text-[#555] leading-relaxed">{f.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
